(() => {
  'use strict';
  function initialize(scope) {
    const roots = scope.matches?.('[data-tun-lemondrop]') ? [scope] : scope.querySelectorAll('[data-tun-lemondrop]');
    roots.forEach(root => {
      if(root.dataset.tllInitialized) return;
      root.dataset.tllInitialized = 'true';
      const inputs = root.querySelectorAll('.tll-pack input[name="id"]');
      const updatePack = () => {
        const selected = root.querySelector('.tll-pack input[name="id"]:checked');
        if(!selected || selected.disabled) return;
        inputs.forEach(input => input.closest('.tll-pack').classList.toggle('tll-selected', input.checked));
        const count = selected.dataset.count;
        const price = selected.dataset.priceLabel;
        const label = root.querySelector('#tll-purchase-label');
        const mobile = root.querySelector('#tll-mobile-price');
        if(label) label.textContent = 'Add ' + count + ' cans — ' + price;
        if(mobile) mobile.textContent = count + ' cans · ' + price;
      };
      inputs.forEach(input => input.addEventListener('change', updatePack));
      updatePack();
      const hero = root.querySelector('#tll-hero-image');
      const frame = root.querySelector('.tll-photo-frame');
      const thumbnails = root.querySelectorAll('.tll-thumb');
      thumbnails.forEach(button => button.addEventListener('click', () => {
        if(!hero || !frame) return;
        hero.src = button.dataset.image;
        hero.alt = button.dataset.alt;
        frame.classList.toggle('tll-award-selected', button.dataset.award === 'true');
        frame.classList.toggle('tll-glass-selected', button.dataset.glass === 'true');
        thumbnails.forEach(item => {
          item.classList.toggle('tll-active', item === button);
          item.setAttribute('aria-pressed', String(item === button));
        });
      }));
    });
  }
  if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
